import axios from "axios"
import {defineStore} from "pinia"
import {computed, ref} from "vue"

const urlActivateVoucher = 'api/v1/voucher/activate'
const urlCheckVoucher = 'api/v1/voucher/check'

export const useVoucherStore = defineStore('VoucherStore', () => {

	const isSubmitting = ref(false)
	const voucherResponse = ref(null)


	const error = computed(() => {
		const httpStatus = voucherResponse.value?.httpStatus

		if (httpStatus > 200) {
			return voucherResponse.value?.message
		}

		return ''
	})

	const voucher = computed(() => {
		if(!error.value) {
			return voucherResponse.value
		}

		return null
	})

	const discountString = computed(() => {
		if(voucher.value) {
			if(voucher.value.voucher_type === 'percentage') {
				return `(-${voucher.value.discount}%)`
			}
			return `(-${voucher.value.discount} ${voucher.value.currency})`
		}

		return ''
	})

	const freeVoucher = computed(() => {
		if (voucher.value) {
			const { voucher_type, discount } = voucher.value
			return voucher_type === 'percentage' && discount === 100
		}
		return false
	})

	const resetVoucher = () => {
		voucherResponse.value = null
	}

	const resetErrorResponse = () => {
		if(error.value) {
			voucherResponse.value = null
		}
	}

	const validateVoucher = (code, subscriptionCode) => {
		isSubmitting.value = true
		axios.post(`${window.api.baseUrl}/${urlCheckVoucher}`, {
			code,
			subscription_type_code: subscriptionCode,
			user_id: window.init.userId || 0
		}).then(({ data, status }) => {
			voucherResponse.value = {
				...data,
				code,
				subscriptionCode,
				httpStatus: status
			}
		}).catch(({response: {status, data}}) => {
			voucherResponse.value = {
				...data,
				httpStatus: status
			}
		}).finally(() => {
			isSubmitting.value = false
		})
	}

	const activateVoucher = async () => {
		if(!voucher.value) {
			return
		}

		return axios.post(`${window.api.baseUrl}/${urlActivateVoucher}`, {
			code: voucher.value.code,
			subscription_type_code: voucher.value.subscriptionCode,
			user_id: window.init.userId || 0
		})
	}

	return {
		discountString,
		isSubmitting,
		error,
		voucher,
		freeVoucher,
		activateVoucher,
		resetVoucher,
		resetErrorResponse,
		validateVoucher
	}
})